// extracted by mini-css-extract-plugin
export default {"container":"YfLe8iHY1uqtfFP3hc2X"};